import { render } from "./DefinitionAdd.vue?vue&type=template&id=4861dd20"
import script from "./DefinitionAdd.vue?vue&type=script&lang=js"
export * from "./DefinitionAdd.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__